import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { NetHoldingsService } from '../../../../services/net-holdings.service';
import { ServiceInspectionService } from '../../../../services/rs/service-inspection.service';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { CustomerTypeService } from '../../../../services/customer-type.service';
import { LocationService } from '../../../../services/location.service';
import { PDAUserService } from '../../../../services/pda-user.service';
import { ReportableService } from '../../../../services/reportable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { Subject } from 'rxjs';
import { AuditLogHistoryService } from '../../../../services/audit-log-history.service';
import { Model } from '@swimlane/ngx-datatable';
import { ColumnService } from '../../../../services/ColumnService';


@Component({
  selector: 'app-audit-log-history',
  templateUrl: './audit-log-history.component.html',
  styleUrls: ['./audit-log-history.component.css']
})
export class AuditLogHistoryComponent implements OnInit {
  @Input() entity_Id: number;
  @Input() entity: string;


  page = new Page();
  rows = Array<any>();
  init: boolean;

  filter: any = {
    quick_Search: ''
  };

  client;

  availableOptions: string[] = [];
  selectedOptions: string[] = [];

  availableOptionsLocations: string[] = [
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'County',
    'Telephone',
    'Fax',
    'Email',
    'Managed',
    'Expired',
    'Updated At',
    'Updated By'
  ];

  selectedOptionsLocations: string[] = [
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'County',
    'Telephone',
    'Fax',
    'Email',
    'Managed',
    'Expired',
    'Updated At',
    'Updated By'
  ];

  selectedOptionsCompanies: string[] = [
    'Name',
    'Account',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'County',
    'Postcode',
    'Telephone',
    'Fax',
    'Email',
    'Expired',
    'Updated At',
    'Updated By'
  ];

  availableOptionsCompanies: string[] = [
    'Name',
    'Account',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'County',
    'Postcode',
    'Telephone',
    'Fax',
    'Email',
    'Expired',
    'Updated At',
    'Updated By'
  ];

  constructor(authService: AuthService, public auditLogHistoryService: AuditLogHistoryService, public reportableService: ReportableService,
    public router: Router, private route: ActivatedRoute, public location: Location, private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

  }

  ngOnInit() {
    this.updateAvailableColumns()
    this.getcolumns();

    if (this.entity_Id != undefined || this.entity_Id != 0) {
      this.loadTable();
      this.init = true;
    }
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable();
  }

  loadTable() {
    this.auditLogHistoryService.getResults(this.page, this.entity_Id, this.entity).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }


  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  downloadReport(id: number) {
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, 'Delivery Notes.pdf'); 
    });
  }

/*  generateExcel() {
    this.cylHistoryService.getExcel(parseInt(this.company_Id)).then((data) => {
        importedSaveAs(data, 'Cylinder_History_' + this.cylinder_Serial_No + '.xlsx');
      });
  }*/

  gotoTop() {
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      top = null;
    }
  }

  updateAvailableColumns() {
    this.availableOptions = this.entity === 'Companies' ? this.availableOptionsCompanies : this.availableOptionsLocations;
    this.selectedOptions = this.entity === 'Companies' ? this.selectedOptionsCompanies : this.selectedOptionsLocations
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    const pageName = this.entity === 'Companies' ? 'auditLogHistoryComapnies' : 'auditLogHistoryLocations'; 
    this.columnService.getColumns(this.client.userId, pageName).then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    const pageName = this.entity === 'Companies' ? 'auditLogHistoryComapnies' : 'auditLogHistoryLocations'; 
    this.columnService.save(this.client.userId, pageName, this.selectedOptions).then((data) => {
    });
  }

}
